<style lang="scss">
  .sender-details{
    &__basic {
      b{
        display: block;
      }
    }
  }
</style>

<!-- eslint-disable -->
<template>
  <article class="sender-details">
    <div class="row">
      <section class="col-3">
        <img width="100%" height="auto" :src="visitor.assets.profile_picture_url" alt="">
        <b-button class="full-width mt-1" @click="showIdentityModel(visitor.assets.identity_picture_url)">View ID</b-button>
        <b-button class="full-width mt-1" @click="showIdentityModel(visitor.assets.identity_picture_back_url)">View Proof of address</b-button>
      </section>

      <section class="col-3 sender-details__basic">
        <h4>Basic Details</h4>

        <p cy="s-name"><b>Name</b> {{visitor.firstname}} {{visitor.lastname}}</p>
        <p cy="s-dob"><b>DOB</b> {{visitor.dob | formatDate}} ( {{visitor.dob | formatDateAge}} )</p>
        <p cy="email"><b>Email</b> {{visitor.email}}</p>
        <p cy="phone"><b>Phone</b> {{visitor.phone_number}}</p>
      </section>

      <section class="col-3">
        <h4>Address</h4>

        <p cy="address1" class="mb-0">{{visitor.address.address1}}</p>
        <p cy="address2" class="mb-0">{{visitor.address.address2}}</p>
        <p cy="address3" class="mb-0">{{visitor.address.address3}}</p>
        <p cy="city" class="mb-0">{{visitor.address.city_town}}</p>
        <p cy="country" class="mb-0">{{visitor.address.country}}</p>
        <p cy="region" class="mb-0">{{visitor.address.region}}</p>
        <p cy="postcode" class="mb-0">{{visitor.address.zip_postal_code}}</p>
      </section>

      <section class="col-3" v-if="showBanButton">
        <b-button variant="danger" @click="showModal('modal-add-ban', true)">Ban Sender</b-button>
      </section>
    </div>

    <b-modal id="modal-identity" size="lg" title="" hide-footer>
      <img width="100%" height="auto" :src="identityUrl" alt="">
    </b-modal>

    <b-modal id="modal-add-ban" title="Add ban" hide-footer>
      <add-ban @refresh="$emit('refresh', true)" :user="visitor" @close="showModal('modal-add-ban', false)"></add-ban>
    </b-modal>

  </article>
</template>
<!-- eslint-enable -->

<script>
  import AddBan from './AddBan.vue';

  export default {
    components: {
      AddBan,
    },
    props: {
      visitor: {
        required: true,
        type: Object,
      },
      showBanButton: {
        type: Boolean,
        required: false,
        default: true,
      },
    },
    data() {
      return {
        identityUrl: '', // correct for the modal to show
      };
    },
    mounted() {

    },
    methods: {
      showIdentityModel(url) {
        this.identityUrl = url;
        this.showModal('modal-identity', true);
      },
      showModal(modalName, value) {
        if (value) {
          this.$bvModal.show(modalName);
        } else {
          this.$bvModal.hide(modalName);
        }
      },
    },
  };
</script>
